import React from 'react';
import PropTypes from 'prop-types';
import { useConnect } from '@lore/query-connect';
import { PayloadStates } from '@lore/utils';
import PendingBanner from './PendingBanner';
import ConnectBanner from './ConnectBanner';
import DeclineBanner from './DeclineBanner';
import LoadingBanner from '../../../pages/_banner/LoadingBanner';
import CompletedBanner from './CompletedBanner';
import CancelledBanner from './CancelledBanner';

Banner.propTypes = {
  claim: PropTypes.object.isRequired,
  offer: PropTypes.object.isRequired
};

export default function Banner(props) {
  const { claim, offer } = props;

  const creator = useConnect('user.byId', {
    id: offer.data.creatorId
  });

  if (creator.state === PayloadStates.FETCHING) {
    return (
      <LoadingBanner creator={creator} />
    );
  }

  // return (
  //   <>
  //     <PendingBanner
  //       offer={offer}
  //       claim={claim}
  //       creator={creator}
  //     />
  //     <ConnectBanner
  //       offer={offer}
  //       creator={creator}
  //       claim={claim}
  //     />
  //     <CompletedBanner
  //       offer={offer}
  //       creator={creator}
  //       claim={claim}
  //     />
  //     <DeclineBanner
  //       offer={offer}
  //       creator={creator}
  //       claim={claim}
  //     />
  //     <CancelledBanner
  //       offer={offer}
  //       creator={creator}
  //       claim={claim}
  //     />
  //   </>
  // );

  if (offer.data.cancelled) {
    return (
      <CancelledBanner
        offer={offer}
        creator={creator}
        claim={claim}
      />
    );
  }

  if (offer.data.completed) {
    return (
      <CompletedBanner
        offer={offer}
        creator={creator}
        claim={claim}
      />
    );
  }

  if (claim.data.response === 'Connect') {
    return (
      <ConnectBanner
        offer={offer}
        creator={creator}
        claim={claim}
      />
    );
  }

  if (claim.data.response === 'Decline') {
    return (
      <DeclineBanner
        offer={offer}
        creator={creator}
        claim={claim}
      />
    );
  }

  return (
    <PendingBanner
      offer={offer}
      claim={claim}
      creator={creator}
    />
  );
}
